import { HttpClient } from '@angular/common/http';
import { Translation } from '@ngneat/transloco/lib/types';
import { getBrowserLang, TranslocoLoader } from '@ngneat/transloco';
import { Injectable } from '@angular/core';
import { AVAILABLE_LANGUAGES } from '@app/models/languages';

@Injectable()
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {}

  getTranslation(lang: string) {
    let locale;

    if (lang) {
      locale = lang;
    } else {
      locale = AVAILABLE_LANGUAGES.find(key => key.includes(getBrowserLang()));
    }

    return this.http.get<Translation>(`/assets/langs/${locale}.json`);
  }
}
